/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyTypeModel } from '../../models/client-survey-type-model';

export interface GetSurveyType$Json$Params {

/**
 * id of surveytype for filter
 */
  surveyTypeId: number;
}

export function getSurveyType$Json(http: HttpClient, rootUrl: string, params: GetSurveyType$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientSurveyTypeModel>> {
  const rb = new RequestBuilder(rootUrl, getSurveyType$Json.PATH, 'get');
  if (params) {
    rb.path('surveyTypeId', params.surveyTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientSurveyTypeModel>;
    })
  );
}

getSurveyType$Json.PATH = '/api/SurveyType/{surveyTypeId}';
